import { groupRelationshipSchema, type GroupRelationship } from "@/schemas";
import { filteredArray } from "@/schemas/utils";

import { QueryKeys } from "../../query-keys";
import { importEntities } from "../index";

/**
 * Import group relationships to the global cache from a list of group relationships.
 *
 * @param groupRelationships - array of GroupRelationships
 */
function importGroupRelationships(groupRelationships: GroupRelationship[]) {
  const parsedResult = filteredArray(groupRelationshipSchema).safeParse(
    groupRelationships,
  );
  if (parsedResult.success) {
    importEntities(QueryKeys.groupRelationships.global, parsedResult.data);
  }
}

export { importGroupRelationships };
